import React, { useEffect, useState } from 'react'
import PageBar from '../../components/dashboard/page-bar/PageBar'
import OwnershipTypes from '../../components/ownership-types/OwnershipTypes'
import axios from 'axios';
import { Loaders } from '../Loaders';

const OwnershipTypesPage = () => {
  const [loader, setLoader] = useState(false)
  const [data, setData] = useState();

  const [count, setCount] = useState(10)
  const [page, setPage] = useState(1)

  const [initialVlue, setInitialVlue] = useState({
    search: '',
  })
  const handleChange = (e) => {
    const clone = { ...initialVlue }
    const value = e.target.value
    const name = e.target.name
    clone[name] = value
    setInitialVlue(clone)
  }
  const ownershipData = async () => {
    setLoader(true)
    const clone = { ...initialVlue, page: page, count: count }
    try {
      const res = await axios.get(
        `https://abarishr.hennainternational.in/api/ownership-type?count=${clone?.count}&page=${clone?.page}&search=${clone?.search}`
      );
      setData(res.data);

      setLoader(false)
    } catch (error) {
      setLoader(false)
      alert("Error");
    }
  };
  const reset = async (page) => {
    setLoader(true)
    const clone = { search: '', page: page, count: count }
    try {
      const res = await axios.get(
        `https://abarishr.hennainternational.in/api/ownership-type?count=${clone?.count}&page=${clone?.page}&search=${clone?.search}`
      );
      setData(res?.data);
      setInitialVlue({
        search: '',
      })
      setLoader(false)
    } catch (error) { }
  }

  useEffect(() => {
    ownershipData(1);
  }, []);

  const handleDelete = async (id) => {
    try {
      const res = await axios.delete(
        `https://abarishr.hennainternational.in/api/ownership-type/delete/${id}`
      );
      ownershipData(1)
    } catch (error) {
      alert("Error");
    }
  };
  const onChangeVal = (e) => {
    ownershipData(e)
  };
  return (
    <>
      {loader && <Loaders />}
      <div className="pageWrapper">
        <PageBar title="Ownership Types" />
        <h3 className='page-title'>Manage Ownership Types </h3>
        <OwnershipTypes data={data} handleDelete={handleDelete} onChangeVal={onChangeVal} initialVlue={initialVlue} handleChange={handleChange} ownershipData={ownershipData} reset={reset} />
      </div>
    </>
  )
}

export default OwnershipTypesPage